export const appVersion = import.meta.env.VITE_APP_VERSION ?? 'dev'
